import {default as r} from "ziggy";
import { Ziggy } from "./ziggy";
import axios from "axios";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import Echo from "laravel-echo";
import startCase from "lodash/startCase";
import toLower from "lodash/toLower";
import marked from "marked";
import PortalVue from "portal-vue";
import sanitizeHtml from "sanitize-html";
import Turbolinks from "turbolinks";
import Vue from "vue";

window.route = function(name, params, absolute) {
  // Make dynamic
  Ziggy.baseUrl = window.location.origin + "/";
  Ziggy.baseDomain = window.location.host;
  Ziggy.baseProtocol = window.location.protocol.replace(":", "");
  return r(name, params, absolute, Ziggy);
}

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.status === 419) {
      window.location.reload();
      return;
    }
    return Promise.reject(error);
  }
);
Vue.prototype.$axios = window.axios;

// Register Components
const files = require.context("./", true, /\.vue$/i);
files.keys().map(key => {
  Vue.component(
    key
      .split("/")
      .pop()
      .split(".")[0],
    {
      inject: ["$page", "$AuthUser", "$session"],
      ...files(key).default
    }
  );
});

Vue.prototype.$sanitizeHtml = sanitizeHtml;

Vue.filter("sentencecase", function(value) {
  return startCase(toLower(value));
});

Vue.use(PortalVue);

Vue.prototype.$config = window.config;

// Start Turbolinks
Turbolinks.start();

window.Pusher = require("pusher-js");

let pusherToken = document.head.querySelector('meta[name="pusher-token"]');
window.Echo = new Echo({
  broadcaster: "pusher",
  key: pusherToken.content,
  cluster: "eu"
  // forceTLS: false
});

// Boot the Vue component
document.addEventListener("turbolinks:load", event => {
  let token = document.head.querySelector('meta[name="csrf-token"]');

  if (typeof ga === "function") {
    /* eslint-disable */
    ga("set", "location", event.data.url);
    ga("send", "pageview");
    /* eslint-enable */
  }

  if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
  } else {
    // eslint-disable-next-line no-console
    console.error(
      "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
  }

  const root = document.getElementById("app");
  const props = JSON.parse(root.dataset.props);
  const session = JSON.parse(root.dataset.session);
  const user = JSON.parse(root.dataset.user);

  if (window.vue) {
    window.vue.$destroy(true);
  }

  Vue.mixin({
    props: {
      state: {
        type: Object,
        required: false,
        default() {
          return {};
        }
      }
    },
    methods: {
      format,
      parseISO,
      route: route,
      parseMarkdown(value, sanitize = true) {
        return marked(value, { sanitize: sanitize });
      },
      autop: function(value) {
        if (!value) return "";
        let breaks = value.split(/[\r\n]+/g);
        return breaks.reduce((html, p) => {
          return (html += `<p>${p}</p>`);
        }, "");
      },
      scrollTop() {
        try {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        } catch {
          window.scrollTo(0, 0);
        }
      },
      getQueryParameterByName(name, url) {
        if (!url) url = window.location.href;
        // eslint-disable-next-line no-useless-escape
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
      }
    }
  });

  window.vue = new Vue({
    provide: {
      $page: props,
      $AuthUser: user ?? false,
      $session: session ?? false
    },
    render: h =>
      h(Vue.component(root.dataset.component), {
        props: {
          state: Object.freeze({
            ...props,
            session,
            user,
            ...{ route: root.dataset.route }
          })
        }
      })
  }).$mount(root);
});
